import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=37d408b2&scoped=true&"
import script from "./DefaultPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=37d408b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d408b2",
  null
  
)

export default component.exports